/**
 * MODULES - counter
 * @author PLEJ
 */

const counter = (() => {

  const init = () => {
    
    const counterElement = document.querySelector('[data-counter]');

    if(counterElement) {
      const start = 0;
      const end = parseInt(counterElement.dataset.counter, 10); 
      const duration = 4000;

      let startTime = null;
      let hasStarted = false;

      function formatNumber(value) {
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }

      function animateCounter(timestamp) {
          if (!startTime) startTime = timestamp;
          const progress = Math.min((timestamp - startTime) / duration, 1);

          const value = Math.floor(progress * (end - start) + start);

          if (progress < 1) {
              counterElement.textContent = formatNumber(value);
              requestAnimationFrame(animateCounter);
          } else {
              counterElement.textContent = formatNumber(end); 
          }
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if(entry.isIntersecting && !hasStarted) {
            hasStarted = true;
            requestAnimationFrame(animateCounter);
          }
        });
      }, {
        threshold: 1.0 
      });

      observer.observe(counterElement);
    }

  };

  return {
    init: init
  };
})();

export {counter}
